import React from 'react';
import { useSelector } from 'react-redux';
import { AlertHeader, Button, Modal, ModalFooter, ModalForm, ModalHeader, ModalText } from 'components';
import { theme } from 'design';
import { selectIsLoadingAPIRequest } from 'store/ApiClient';
import { Employee } from 'store/Employee';
import { IStore } from 'store/types';
import { HeaderContent } from './styles';

interface ActivateAccountProps {
  isActive: boolean;
  onActivate: () => void;
  onClose: () => void;
}

const ActivateUser = ({ isActive, onActivate, onClose }: ActivateAccountProps) => {
  const isLoading = useSelector((state: IStore) => selectIsLoadingAPIRequest(state, Employee.UPDATE_EMPLOYEE_REQUEST));

  return (
    <Modal isActive={isActive} onClose={onClose}>
      <ModalHeader style={{ paddingBottom: '0' }}>
        <HeaderContent>
          <AlertHeader icon="CheckmarkThick" iconFill={theme.color.success.medium} title="Activate User?" />
          <ModalText>Activating a user will enable them to receive payments.</ModalText>
        </HeaderContent>
      </ModalHeader>
      <ModalForm>
        <ModalFooter columns={2}>
          <Button label="Cancel" appearance="white" size="large" onClick={onClose} />
          <Button label="Activate" disabled={false} isProcessing={isLoading} type="button" appearance="primary" size="large" onClick={onActivate} />
        </ModalFooter>
      </ModalForm>
    </Modal>
  );
};

export default ActivateUser;
